import { createSlice,createAsyncThunk } from '@reduxjs/toolkit'
import {indexBanner} from '@/api/'


const initialState = {
  value: 0,
  bannerList:[]
}

export const getBannerList = createAsyncThunk('index/getIndexBaner', async (param) => {
  const payload = await indexBanner(param)
  return payload
})

export const indexSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    increment: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1
    },
    decrement: (state) => {
      state.value -= 1
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBannerList.fulfilled, (state, { payload }) => {
      // console.log(payload)
      payload && payload.code===0&&(state.bannerList = payload.data);
    })
  }
})

// Action creators are generated for each case reducer function
// export const { increment, decrement, incrementByAmount } = indexSlice.actions

export default indexSlice.reducer